import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=ba470fdc"
import script from "./comment-item.vue?vue&type=script&lang=js"
export * from "./comment-item.vue?vue&type=script&lang=js"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=ba470fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./comment-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports